<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                v-model="queryForm.qstr"
                placeholder="名稱"
                size="small"
                style="width:100px"
              ></el-input>
            </el-form-item>

            <el-form-item label="顏色" label-width="65px">
              <div
                style="width:335px;marginBottom:-20px"
                >
                <el-checkbox-group v-model="queryForm.colors">
                  <el-checkbox
                    v-for="itemColor in extTagColorList"
                    :key="itemColor.name"
                    :label="itemColor.name"
                    style="width:35px"
                  >
                    <span :style="{ color: itemColor.textColor, marginLeft: '-5px'}" >
                      {{ itemColor.txtLabel }}
                    </span>
                  </el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                style="marginLeft:-10px"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addNewDept"
            size="small"
            >新增部門</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 單位：{{ myownOrg }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="departments"
            @sort-change="sortChange"
            :default-sort="{ prop: 'startDate', order: 'descending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <el-table-column
              label="部門名稱"
              prop="name"
              sortable="custom"
              width="200"
            >
              <template #default="scope">
                <el-tag 
                  :style="getTagStyle(scope.row.color)"
                  >{{ scope.row.name }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="管理員"
              prop="deptUsers"
              :sortable="false"
              width="200"
            >
              <template #default="scope">
                <el-tag effect="plain" type="info" v-for="deptUser in scope.row.deptUsers"
                    :key="deptUser.id"
                    :label="deptUser.user.name"
                  >{{ deptUser.user.name }}</el-tag>
              </template>
            </el-table-column>
            <!--<el-table-column label="管理者" prop="admins" width="250">-->
            <!--<template #default="scope">-->
            <!--{{ getAdminNames(scope.row.admins) }}-->
            <!--</template>-->
            <!--</el-table-column>-->

            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="editDepartment(scope.row.id)"
                  >編輯
                </el-button>

                <el-button size="mini" @click="assignDeptAdmin(scope.row)"
                  >設定部門管理員
                </el-button>

                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteDepartment(scope.row.id)"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <AddEdtDeptDlg
          v-model="isDlgVisible"
          :selectedItemId="selectedItemId"
          :key="`deptDlg_${dlgKey}`"
        ></AddEdtDeptDlg>

        <EditDeptAdminDlg
          v-model="isEditDeptAdminVisible"
          :deptId="selectedItemId"
          :deptName="selectedDeptName"
          :key="`deptAdminDlg_${deptAdmDlgKey}`"
        ></EditDeptAdminDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddEdtDeptDlg from "@/components/org/AddEdtDeptDlg";
import EditDeptAdminDlg from "@/components/org/EditDeptAdminDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  name: "deptList",
  mixins: [tagColorsMixin],
  components: {
    AddEdtDeptDlg,
    EditDeptAdminDlg,
  },
  created() {
    this.$store.dispatch("department/list", {
      max: this.pageSize,
      offset: this.offset,
      sort: this.sort,
      order: this.order,
    });
  },
  data() {
    return {
      selectedItemId: null,
      selectedDeptName: "",
      dlgKey: 0,
      deptAdmDlgKey: 0,
      isDlgVisible: false,
      isEditDeptAdminVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
        colors: [],
      },
    };
  },
  methods: {
    getAdminNames(admins) {
      return admins.reduce((acc, cur) => {
        return `${acc}${cur.name}; `;
      }, "");
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.query(this.pageSize, 0, this.sort, this.order, queryForm);
    },
    addNewDept() {
      this.isDlgVisible = true;
      this.selectedItemId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    assignDeptAdmin(dept) {
      this.selectedItemId = dept.id;
      this.selectedDeptName = dept.name;
      this.deptAdmDlgKey = this.deptAdmDlgKey ? 0 : 1;
      this.isEditDeptAdminVisible = true;
    },
    editDepartment(itemId) {
      /*console.log(`editDepartment: itemId = ${itemId}`);*/
      this.selectedItemId = itemId;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.queryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.queryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("department/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    deleteDepartment(itemId) {
      this.$confirm("此操作將永久刪除該部門, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("department/remove", itemId).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.queryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("department/SET_SORT", "id");
        this.$store.commit("department/SET_ORDER", "ascending");
      } else {
        this.$store.commit("department/SET_SORT", args.prop);
        this.$store.commit("department/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.queryForm
      );
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      departments: "department/departments",
      total: "department/total",
      offset: "department/offset",
      getDeptById: "department/getDeptById",
      sort: "department/sort",
      order: "department/order",
    }),
  },
};
</script>

<style scoped>
.tagcolorcheck {
  width: 10px;
}
